































































































import {Vue, Component, Prop, Watch, Provide} from 'vue-property-decorator'
import {State, Getter, Action, Mutation, namespace} from 'vuex-class'
import _ from 'lodash'

@Component
export default class extends Vue {
  @Prop({
    default: () => ({
      page: 1,
      sortBy: ['createdAt'],
      sortDesc: [true],
      itemsPerPage: 10,
    }),
  }) public options!: OptionTable
  @Prop() public headers!: Array<{
    text: string,
    value: string,
    width: number,
  }>
  @Prop() public defaultFilters!: {
    [key: string]: Array<{
      condition: string,
      value: string,
    }>,
  }
  @Provide('formName') public formName = 'ListDataTable'
  @Prop() public showSelect!: boolean
  @Prop({default: false}) public showSummary!: boolean
  @Prop() public items!: Array<{ [key: string]: any }>
  @Prop() public hideDefaultHeader!: boolean
  @Prop({default: () => []}) public selectedItems!: Array<{ [key: string]: any }>
  @Prop({default: () => null}) public getListsAction!: () => void
  @Prop() public serverItemsLength!: number
  @Prop({default: false}) private loadingDataTable!: boolean
  @Prop({default: false}) private disableSearch!: boolean
  @Prop({default: 'ไม่มีข้อมูล'}) private noDataText!: string
  @Prop({default: false}) private hideDefaultFooter!: boolean
  @Prop({default: false}) private showEmptyDataDisplay!: boolean
  @Prop({default: false}) private disableFilterAndSort!: boolean
  @Prop({default: false}) private hideTableBorder!: boolean
  @Prop({default: false}) private showCreateButton!: boolean
  @Prop({default: () => null}) private createButton!: () => void
  @Prop({default: false}) private multiSort!: boolean
  @Prop({default: ''}) private startDate!: string
  @Prop({default: ''}) private endDate!: string
  @Prop({default: false}) private date!: boolean

  private hideAddFilter = false
  private menuOpened = {}

  get filters(): {
    [key: string]: Array<{
      condition: string,
      value: string,
    }>,
  } {
    return this.defaultFilters || {}
  }

  get option() {
    return _.cloneDeep(this.options)
  }

  set option(option: OptionTable) {
    this.$emit('update:options', option)
    this.doGetLists()
  }

  get indeterminate() {
    return !this.selectAll && _.size(_.filter(this.items, (item) => _.find(this.selectedItems, '_id'))) > 0
  }

  get selectAll() {
    const sizeItem = this.items.length
    return sizeItem && _.size(_.filter(this.items, (item) => {
      return _.find(this.selectedItems, {_id: item._id})
    })) === sizeItem
  }

  set selectAll(val: boolean) {
    let newSelectedAll = []
    const itemsFilterId = _.map(this.items, '_id')
    if (val) {
      newSelectedAll = _.uniq([...this.selectedItems, ...itemsFilterId])
    } else {
      newSelectedAll = _.difference(this.selectedItems, itemsFilterId)
    }
    this.$emit('update:selectedItems', newSelectedAll)
  }

  public created() {
    this.doGetLists()
    if (this.$route.query.search) {
      this.options.search = this.$route.query.search as string
      // this.$router.push(this.$route.path)
    }
  }

  private checkfilterActive(key: string) {
    return !_.isEmpty(this.filters[key])
  }

  // private checkFilterEmpty(keyIndex: string) {
  //   let checkValue = true
  //   this.filters[keyIndex].forEach((filter: any) => {
  //     if (filter.value === '' || filter.condition === '') {
  //       checkValue = false
  //     }
  //   })
  //   this.hideAddFilter = checkValue
  //   return checkValue
  // }

  private async updateDate(value: any, key: string) {
    this.$emit('update:' + key, value)
    await this.doGetLists()
  }

  private async doGetLists() {
    await this.getListsAction()
  }
}
